// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:host {
  display: flex;
  height: 100%;
  flex-direction: column;
  overflow: hidden;
}

.pins-header {
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 10px 12px;
  flex-shrink: 0;
}
.pins-header .pins-header-icon {
  font-size: 18px;
  width: 18px;
  height: 18px;
  opacity: 0.7;
}
.pins-header .pins-title {
  font-weight: 600;
  font-size: 14px;
}
.pins-header .flex-spacer {
  flex: 1;
}

.pins-list {
  flex: 1;
  overflow-y: auto;
  padding: 8px 0;
}

.pin-card {
  padding: 10px 12px;
  transition: background 0.1s ease;
}
.pin-card .pin-card-header {
  display: flex;
  align-items: center;
  gap: 6px;
  margin-bottom: 6px;
}
.pin-card .pin-card-header .flex-spacer {
  flex: 1;
}
.pin-card .pin-card-header .pin-role-icon {
  font-size: 16px;
  width: 16px;
  height: 16px;
}
.pin-card .pin-card-header .pin-timestamp {
  font-size: 11px;
}
.pin-card .pin-card-header .jump-btn,
.pin-card .pin-card-header .unpin-btn {
  --square-button-size: 24px;
  --square-icon-size: 14px;
  transition: opacity 0.15s ease;
  display: flex;
  align-items: center;
  justify-content: center;
}
.pin-card .pin-card-header .jump-btn mat-icon,
.pin-card .pin-card-header .unpin-btn mat-icon {
  display: flex;
  align-items: center;
  justify-content: center;
}
.pin-card .pin-card-header .jump-btn {
  opacity: 0.5;
}
.pin-card .pin-card-header .jump-btn:hover {
  opacity: 1;
}
.pin-card .pin-card-header .unpin-btn {
  opacity: 0.5;
}
.pin-card .pin-card-header .unpin-btn:hover {
  opacity: 1;
}
.pin-card .pin-card-content {
  font-size: 13px;
  line-height: 1.5;
  overflow: hidden;
}
.pin-card .pin-card-content:not(.expanded) {
  max-height: 120px;
  mask-image: linear-gradient(to bottom, black 70%, transparent 100%);
  -webkit-mask-image: linear-gradient(to bottom, black 70%, transparent 100%);
}
.pin-card .pin-card-content ::ng-deep h1, .pin-card .pin-card-content ::ng-deep h2, .pin-card .pin-card-content ::ng-deep h3, .pin-card .pin-card-content ::ng-deep h4 {
  font-size: 14px;
  margin: 4px 0;
}
.pin-card .pin-card-content ::ng-deep p {
  margin: 4px 0;
}
.pin-card .pin-card-content ::ng-deep pre {
  font-size: 11px;
  padding: 6px;
  overflow-x: auto;
}
.pin-card .pin-card-content ::ng-deep ul, .pin-card .pin-card-content ::ng-deep ol {
  padding-left: 20px;
  margin: 4px 0;
}
.pin-card .pin-card-content ::ng-deep code {
  font-size: 12px;
}
.pin-card .pin-card-content ::ng-deep app-tool-message {
  display: block;
}
.pin-card .show-more-btn {
  font-size: 11px;
  padding: 0 4px;
  min-height: 24px;
  line-height: 24px;
}

.pins-empty {
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 32px 16px;
  opacity: 0.5;
  font-size: 13px;
}`, "",{"version":3,"sources":["webpack://./src/app/components/pins-pane/pins-pane.component.scss"],"names":[],"mappings":"AAAA;EACE,aAAA;EACA,YAAA;EACA,sBAAA;EACA,gBAAA;AACF;;AAEA;EACE,aAAA;EACA,mBAAA;EACA,QAAA;EACA,kBAAA;EACA,cAAA;AACF;AACE;EACE,eAAA;EACA,WAAA;EACA,YAAA;EACA,YAAA;AACJ;AAEE;EACE,gBAAA;EACA,eAAA;AAAJ;AAGE;EACE,OAAA;AADJ;;AAKA;EACE,OAAA;EACA,gBAAA;EACA,cAAA;AAFF;;AAKA;EACE,kBAAA;EACA,gCAAA;AAFF;AAIE;EACE,aAAA;EACA,mBAAA;EACA,QAAA;EACA,kBAAA;AAFJ;AAII;EACE,OAAA;AAFN;AAKI;EACE,eAAA;EACA,WAAA;EACA,YAAA;AAHN;AAMI;EACE,eAAA;AAJN;AAOI;;EAEE,0BAAA;EACA,wBAAA;EACA,8BAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;AALN;AAOM;;EACE,aAAA;EACA,mBAAA;EACA,uBAAA;AAJR;AAQI;EACE,YAAA;AANN;AAOM;EAAU,UAAA;AAJhB;AAOI;EACE,YAAA;AALN;AAMM;EAAU,UAAA;AAHhB;AAOE;EACE,eAAA;EACA,gBAAA;EACA,gBAAA;AALJ;AAOI;EACE,iBAAA;EACA,mEAAA;EACA,2EAAA;AALN;AASM;EAAiB,eAAA;EAAiB,aAAA;AALxC;AAMM;EAAI,aAAA;AAHV;AAIM;EAAM,eAAA;EAAiB,YAAA;EAAc,gBAAA;AAC3C;AAAM;EAAS,kBAAA;EAAoB,aAAA;AAInC;AAHM;EAAO,eAAA;AAMb;AALM;EAAmB,cAAA;AAQzB;AAJE;EACE,eAAA;EACA,cAAA;EACA,gBAAA;EACA,iBAAA;AAMJ;;AAFA;EACE,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,kBAAA;EACA,YAAA;EACA,eAAA;AAKF","sourcesContent":[":host {\n  display: flex;\n  height: 100%;\n  flex-direction: column;\n  overflow: hidden;\n}\n\n.pins-header {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  padding: 10px 12px;\n  flex-shrink: 0;\n\n  .pins-header-icon {\n    font-size: 18px;\n    width: 18px;\n    height: 18px;\n    opacity: 0.7;\n  }\n\n  .pins-title {\n    font-weight: 600;\n    font-size: 14px;\n  }\n\n  .flex-spacer {\n    flex: 1;\n  }\n}\n\n.pins-list {\n  flex: 1;\n  overflow-y: auto;\n  padding: 8px 0;\n}\n\n.pin-card {\n  padding: 10px 12px;\n  transition: background 0.1s ease;\n\n  .pin-card-header {\n    display: flex;\n    align-items: center;\n    gap: 6px;\n    margin-bottom: 6px;\n\n    .flex-spacer {\n      flex: 1;\n    }\n\n    .pin-role-icon {\n      font-size: 16px;\n      width: 16px;\n      height: 16px;\n    }\n\n    .pin-timestamp {\n      font-size: 11px;\n    }\n\n    .jump-btn,\n    .unpin-btn {\n      --square-button-size: 24px;\n      --square-icon-size: 14px;\n      transition: opacity 0.15s ease;\n      display: flex;\n      align-items: center;\n      justify-content: center;\n\n      mat-icon {\n        display: flex;\n        align-items: center;\n        justify-content: center;\n      }\n    }\n\n    .jump-btn {\n      opacity: 0.5;\n      &:hover { opacity: 1; }\n    }\n\n    .unpin-btn {\n      opacity: 0.5;\n      &:hover { opacity: 1; }\n    }\n  }\n\n  .pin-card-content {\n    font-size: 13px;\n    line-height: 1.5;\n    overflow: hidden;\n\n    &:not(.expanded) {\n      max-height: 120px;\n      mask-image: linear-gradient(to bottom, black 70%, transparent 100%);\n      -webkit-mask-image: linear-gradient(to bottom, black 70%, transparent 100%);\n    }\n\n    ::ng-deep {\n      h1, h2, h3, h4 { font-size: 14px; margin: 4px 0; }\n      p { margin: 4px 0; }\n      pre { font-size: 11px; padding: 6px; overflow-x: auto; }\n      ul, ol { padding-left: 20px; margin: 4px 0; }\n      code { font-size: 12px; }\n      app-tool-message { display: block; }\n    }\n  }\n\n  .show-more-btn {\n    font-size: 11px;\n    padding: 0 4px;\n    min-height: 24px;\n    line-height: 24px;\n  }\n}\n\n.pins-empty {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  padding: 32px 16px;\n  opacity: 0.5;\n  font-size: 13px;\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
